import { IAdvertising } from '@r1-frontend/shared/types/shopItems/IAdvertising';

export interface ILabel {
    id: number,
    name: string,
    title: string,
    color: string,
    color_text: string,
}

export interface IMenuItem {
    id: number,
    title: string,
    link: string,
    weight: number,
    desc?: string,
    add_desc?: string,
    available: 1 | 0,
    parent: 1 | 0,
    parent_id: unknown,
    view: 0 | 1 | 2,
    promoted: 1 | 0,
    button_link?: string,
    button_text?: string,
    promo_title?: string,
    promo_link?: string,
    promo_description?: string,
    name?: string,
    image: string,
    image_webp: string,
    image_icon?: string,
    image_icon_webp?: string,
    type?: string,
    image_animated?: string,
    category_id?: unknown,
    children?: IMenuItem[],
    parent_ids?: number[],
    labels?: ILabel[],
    advertising?: IAdvertising,
}

export enum MenuType {
    COMMON = 'common',
    DESCRIPTION_LABEL = 'description-label',
    DESCRIPTION_BUTTON = 'description-button',
    DESCRIPTION_BUTTON_IMAGE = 'description-button-image',
}

export interface IMenuByTypesChild {
    title: string,
    type: MenuType,
    children: IMenuItem[],
}

export interface IMenuByTypesItem extends Omit<IMenuItem, 'children'> {
    children: IMenuByTypesChild[],

    [key: string]: unknown,
}
